import { createContext, useContext } from "react";
import { type HousingSearchForm } from "~/features/selectionAssistant/housing/types/housingSAFormTypes";

export type HousingSearchFormKey = keyof HousingSearchForm;

export type HousingResetFunc = (forceSubmit?: boolean, ...keys: HousingSearchFormKey[]) => void;

export const HousingResetContext = createContext<HousingResetFunc>(() => {
  throw new Error("Missing Reset Context");
});

export const useHSAResetAction = () => useContext(HousingResetContext);
